export default "__VITE_PUBLIC_ASSET__319eef82__"